var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{},[_c('NavBarHome',{staticStyle:{"z-index":"20"},attrs:{"isLight":"false"}}),_c('Carrusel',{attrs:{"clas":"offsetme"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }